import Analytics from '@withlocals/withlocals-analytics';
import LocalizedLinkButton from 'components/RoundedButton/LocalizedLinkButton';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const CSS = require('./ServerError.module.scss');

function ServerErrorInternal() {
  const location = useLocation();

  const getErrorFromQueryString = () => {
    const params = new URLSearchParams(location.search);
    return {
      status: params.get('statusCode') || '500',
      message: params.get('message'),
    };
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('statusCode') || '500';
    Analytics.track(status, location.pathname, window.document.referrer);
    window.scrollTo(0, 0);
  }, [location]);

  const params = getErrorFromQueryString();

  return (
    <div className={CSS.ServerErrorContainer}>
      <Helmet>
        <meta name="render:status_code" content={params.status} />
      </Helmet>
      <div className={CSS.ServerErrorHeader}>
        <h1 className={CSS.ServerErrorTitle}>
          Internal server error {params.status}
        </h1>
        <p>Server returned an error message: '{params.message}'</p>
      </div>
      <div className={CSS.ServerErrorSubtitleContainer}>
        <LocalizedLinkButton
          to={'/'}
          className={CSS.ServerErrorSubtitle}
          inverted
        >
          Find your destination
        </LocalizedLinkButton>
      </div>
    </div>
  );
}

export const serverErrorRoute: RouteDescriptor = {
  id: 'error.server',
  path: `${basePath}/error/`,
  label: 'Server Error',
  audience: 'both',
  layout: 'navigational',
  module: 'errorpages',
};

export const errorRoutes = [
  createNavigationalRoute({
    key: serverErrorRoute.id,
    id: serverErrorRoute.id,
    path: serverErrorRoute.path,
    component: ServerErrorInternal,
    handle: createRouteHandle(serverErrorRoute),
    showSearchInNavbar: true,
    nonFixedNavbar: true,
  }),
];

export const errorRouteDescriptors = [serverErrorRoute];

export default errorRoutes;
